import { RoleService } from './../shared/role.service';
import { Role } from './../shared/role.model';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import * as $ from 'jquery';
import { ModulosListComponent } from './modulos-list.component';
import { ModulosService } from './modulos.service';
import { IModulo } from './modulo';
// import { IRol} from '../roles/rol';
// import { RolesService } from '../roles/roles.service';
import * as myGlobals from './../global';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-edit-modulo',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.sass'],
  providers: [ModulosService]
})
export class EditModuloComponent implements OnInit, AfterViewInit, OnDestroy {
  private _moduloService;
  private _rolesService;
  roles: Role[] = [];
  modulos: IModulo[] = [];
  errorMessage = '';
  modulo: IModulo;

  constructor(
    private rolesService: RoleService,
    private moduloService: ModulosService,
    private parent: ModulosListComponent
  ) {
    this._moduloService = moduloService;
    this._rolesService = rolesService;
  }

  ngAfterViewInit() {
    $('a[rel=modulos]').addClass('selected');
  }

  ngOnInit() {
    console.log(this.parent.editnumber);
    this.getModulo(this.parent.editnumber);
    // this.getActiveRoles();
  }

  edit(elemento): boolean {
    console.log('edit:' + elemento.parent.editnumber);
    const formData = {
      nombre: $('input[name=nombre]').val(),
      id_pantalla: $('input[name=id_pantalla]').val(),
      rol_id: $('#myselect option:selected').val()
    };
    console.log(formData);
    $.ajax({
      url: myGlobals.baseApi + '/api/modulos/' + elemento.parent.editnumber,
      type: 'PUT',
      data: formData
    }).done(function(response) {
      //
      console.log('edit sucess!!');

    }).fail(function(jqXHR) {
      alert('No se pudo actualizar el modulo: ' + errorMessageFromAjax(jqXHR));
    });
    return false;
  }
  getModulo(id: number) {
    this.moduloService
      .getModulo(id)
      .subscribe(modulo => (this.modulo = modulo), error => (this.errorMessage = error as any));
  }

  ngOnDestroy() {
    $('a[rel=modulos]').removeClass('selected');
  }
}
